import { useState } from 'react';
import { Dialog, api, useToast } from './_barrel.js';


        function SignoffDialog({ token, incident, onClose, onSuccess }) {
            const transitions = {
                draft: ['triaged'],
                triaged: ['under_review', 'false_positive'],
                under_review: ['escalated', 'closed', 'triaged'],
                escalated: ['closed', 'under_review'],
                closed: ['under_review'],
                false_positive: ['triaged'],
            };
            const options = transitions[incident.status] || [];

            const [toStatus, setToStatus] = useState(options[0] || '');
            const [reason, setReason] = useState('');
            const [submitting, setSubmitting] = useState(false);
            const [error, setError] = useState(null);
            const toast = useToast();

            const submit = async (e) => {
                e.preventDefault();
                setSubmitting(true);
                setError(null);
                try {
                    const body = {
                        incident_id: incident.id,
                        from_status: incident.status,
                        to_status: toStatus,
                        reason: reason || null,
                    };
                    await api(`/api/v1/incidents/${incident.id}/signoff`, { method: 'POST', body: JSON.stringify(body) }, token);
                    toast(`Incident moved to ${toStatus}`);
                    onSuccess?.();
                    onClose();
                } catch (err) { setError(err.message); }
                finally { setSubmitting(false); }
            };

            return (
                <Dialog onClose={onClose} title="Sign-Off Transition">
                    <div className="mb-4">
                        <div className="font-display text-lg mb-1">{incident.title}</div>
                        <div className="text-xs font-mono text-muted">Currently <span className="gold">{incident.status}</span></div>
                    </div>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label>Move To</label>
                            <select value={toStatus} onChange={e => setToStatus(e.target.value)}>
                                {options.map(o => <option key={o} value={o}>{o.replace('_',' ')}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Reason (Recommended)</label>
                            <textarea rows="3" value={reason} onChange={e => setReason(e.target.value)}
                                placeholder="Why this transition? Your reasoning is recorded against your name in the audit chain."></textarea>
                        </div>
                        <div className="text-xs text-muted">This sign-off will be sequenced and attributed to you in the hash-chained audit log. It cannot be deleted.</div>
                        {error && <div className="text-[var(--red)] text-sm">{error}</div>}
                        <div className="flex justify-end gap-3 pt-2">
                            <button type="button" className="btn-ghost" onClick={onClose}>Cancel</button>
                            <button type="submit" className="btn-gold" disabled={submitting}>{submitting ? 'Signing…' : 'Sign Off'}</button>
                        </div>
                    </form>
                </Dialog>
            );
        }

export { SignoffDialog };
